import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from './components/LoginForm';
import { LOGIN_REDIRECT_PATH_STORAGE_NAME } from './actions';
import { REDIRECT_QUERY_PARAM_NAME } from '../../common/services/AuthenticationRules';

function LoginPage(props) {
  const {
    clearFetchingStatus, login, loginViaCode, error, isFetching, config,
  } = props;
  const [submitted, setSubmitted] = useState(false);
  const code = (new URLSearchParams(useLocation().search)).get('code');

  const submitHandler = (values) => {
    login(values);
    setSubmitted(true);
  };

  useEffect(clearFetchingStatus, []);

  useEffect(() => {
    const redirectPath = (new URL(window.location.href))
      .searchParams.get(REDIRECT_QUERY_PARAM_NAME);

    if (redirectPath) {
      localStorage.setItem(LOGIN_REDIRECT_PATH_STORAGE_NAME, redirectPath);
    }

    if (code) {
      setSubmitted(true);
      loginViaCode(code);
    }
  }, [code]);

  return (
    <div className="login-wrapper">
      <LoginForm
        onSubmit={submitHandler}
        submitted={submitted}
        errorMessage={error}
        isFetching={isFetching}
        config={config}
      />
    </div>
  );
}

export default LoginPage;
